export default __webpack_public_path__ + "static/national-debt-relief-2-ccbcc899f3d1947314b1cd6799f78e1c.png";